export default __webpack_public_path__ + "static/macbook-b1cd77d77360f3de0cc2bd7b44746f7c.png";